const COMPRESSION_OPTIONS = Object.freeze({
  maxSizeMB: 2,
  maxWidthOrHeight: 2048,
  maxIteration: 10,
  initialQuality: 0.85,
  preserveExif: false
});

function normalizeCompressedFile(compressed, source) {
  if (compressed instanceof File && compressed.name === source.name) return compressed;
  return new File([compressed], source.name, {
    type: compressed.type || source.type,
    lastModified: source.lastModified
  });
}

async function compressOnMainThread(file) {
  const { default: imageCompression } = await import('browser-image-compression');
  return imageCompression(file, { ...COMPRESSION_OPTIONS, useWebWorker: false });
}

function compressInWorker(file) {
  return new Promise((resolve, reject) => {
    const worker = new Worker(new URL('./imageUpload.worker.js', import.meta.url), { type: 'module' });
    const finish = (callback, value) => {
      worker.terminate();
      callback(value);
    };
    worker.onmessage = (event) => {
      if (event.data?.error) {
        finish(reject, new Error(event.data.error));
        return;
      }
      finish(resolve, event.data?.file);
    };
    worker.onerror = (event) => finish(reject, new Error(event.message || 'Image compression worker failed'));
    worker.postMessage({ file, options: COMPRESSION_OPTIONS });
  });
}

export async function prepareImageForUpload(file) {
  let compressed;
  if (typeof Worker === 'function') {
    try {
      compressed = await compressInWorker(file);
    } catch {
      compressed = await compressOnMainThread(file);
    }
  } else {
    compressed = await compressOnMainThread(file);
  }

  const normalized = normalizeCompressedFile(compressed, file);
  if (normalized.size >= file.size) {
    return { file, compressed: false, originalSize: file.size };
  }
  return { file: normalized, compressed: true, originalSize: file.size };
}
